import { useFormContext } from "react-hook-form";

import { useTranslation } from "react-i18next";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupInput } from "src/components/Shared/NewForms/NFLookupInput";
import { NFLookupPriceType } from "src/components/Shared/NewForms/NFLookupPriceType";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { VatTypeEnum } from "src/enums/VatTypeEnum";
import { AmountHelper } from "src/helpers/AmountHelper";
import { EnumHelper } from "src/helpers/EnumHelper";

export const CustomerInvoicesDetailProducts = () => {
  const tableName = "products";
  const { setValue, getValues } = useFormContext();
  const { t } = useTranslation();

  const handleVatTypeChanged = (newVatType: VatTypeEnum, index: number) => {
    setValue(`${tableName}.${index}.vatAmount`, AmountHelper.getVatAmount(newVatType, getValues(`${tableName}.${index}.amount`), getValues("priceIncludesVat")));
  };

  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
      newQuantity,
      getValues(`${tableName}.${index}.price`),
      getValues(`${tableName}.${index}.vatType`),
      getValues("priceIncludesVat")
    );
    setValue(`${tableName}.${index}.amount`, newAmounts.amount);
    setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
    setValue(`${tableName}.${index}.amountWithVat`, newAmounts.amountWithVat);
  };

  const handlePriceChanged = (newPrice: number, index: number) => {
    const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
      getValues(`${tableName}.${index}.quantity`),
      newPrice,
      getValues(`${tableName}.${index}.vatType`),
      getValues("priceIncludesVat")
    );
    setValue(`${tableName}.${index}.amount`, newAmounts.amount);
    setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
    setValue(`${tableName}.${index}.amountWithVat`, newAmounts.amountWithVat);
  };
  return (
    <>
      <NFormTable fieldArray={tableName}>
        <NFLookupProduct fieldName={"productId"} title={t("Product")} width={200} />
        <NFLookupUnit title={t("Unit")} fieldName="unitId" width={200} />

        <NFIntInput fieldName={"quantity"} title={t("Quantity")} onValueChanged={handleQuantityChanged} width={100} />

        <NFIntInput fieldName={"amount"} title={t("Amount")} width={100} />
        <NFIntInput fieldName={"vatAmount"} title={t("vatAmount")} width={150} />
        <NFLookupPriceType fieldName={"priceTypeId"} title={t("PriceType")} width={250} />
        <NFIntInput fieldName={"price"} title={t("Price")} onValueChanged={handlePriceChanged} width={100} />
        <NFLookupInput title={t("vatType")} fieldName={"vatType"} items={EnumHelper.GetVatTypeArrayForLookup()} width={150} />

        <NFIntInput fieldName={"amountWithVat"} title={t("amountWithVat")} width={100} />
        <NFIntInput fieldName={"vatRate"} title={t("vatRate")} width={100} onValueChanged={handleVatTypeChanged} />
      </NFormTable>
    </>
  );
};
